import { useState, useEffect } from 'react';
import { IS_SERVER } from '../constants';

var defaultState = {
  height: null,
  width: null
};

export function useResize() {
  var _useState = useState(IS_SERVER ? defaultState : getWindowSize()),
      size = _useState[0],
      setSize = _useState[1];

  function getWindowSize() {
    return {
      height: window.innerHeight,
      width: window.innerWidth
    };
  }

  useEffect(function () {
    function handleResize() {
      setSize(getWindowSize());
    }

    window.addEventListener('resize', handleResize, false);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [setSize]);

  return size;
}